import type { UserProfileData } from 'chaika-frontend-types/frontend-cms';

export function readPaymentWorkplaceIdsByClinic(
    additionalData: UserProfileData['additionalData'],
): Record<string, string> {
    const { selectedPaymentWorkplaceIds = {}, selectedOrganizationId, selectedOfficeId } = additionalData ?? {};

    if (!selectedOrganizationId || !selectedOfficeId || selectedOrganizationId in selectedPaymentWorkplaceIds) {
        return selectedPaymentWorkplaceIds;
    }

    return { ...selectedPaymentWorkplaceIds, [selectedOrganizationId]: selectedOfficeId };
}
